export const parseFlag = (rawValue: string | undefined) => {
  const value = (rawValue || '').trim().toLocaleLowerCase();
  return ['true', 'on', 'yes', '1'].includes(value);
};
